export default __webpack_public_path__ + "static/WEMC-logo.png";